import React from 'react'

const arrowLeft = () => (
  <svg width="32" height="22" viewBox="0 0 32 22" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 11C32 11.4673 31.5984 11.8462 31.1029 11.8462L3.5181 11.8462L13.0941 20.5443C13.451 20.8685 13.4617 21.4041 13.1181 21.7408C12.7744 22.0774 12.2065 22.0875 11.8497 21.7633L9.61651e-07 11L11.8497 0.2367C12.2065 -0.0874998 12.7744 -0.0774006 13.1181 0.259199C13.4617 0.595799 13.451 1.1315 13.0941 1.4557L3.5181 10.1538L31.1029 10.1538C31.5984 10.1538 32 10.5327 32 11Z"/>
  </svg>
)

export default arrowLeft
